// Checkout.jsx
import React from 'react';
import Payment from './Payment'; // The embedded payment form test

const Checkout = ({ cart, total, userId }) => {
  return (
    <div className="max-w-2xl mx-auto py-20 px-4">
      <h1 className="text-3xl font-bold mb-6 text-purple-700">Checkout</h1>
      <ul className="divide-y">
        {cart.map(item => (
          <li key={item.sku} className="py-4 flex justify-between items-center">
            <div className="flex items-center gap-4">
              <img
                src={item.imageUrl || 'https://via.placeholder.com/64'}
                alt={item.name}
                className="w-16 h-16 object-cover rounded-lg border"
              />
              <span>{item.name} (x{item.quantity})</span>
            </div>
            <span className="font-semibold">${(item.price * item.quantity).toFixed(2)}</span>
          </li>
        ))}
      </ul>
      <div className="mt-6 text-right text-xl font-semibold">
        Total: <span className="text-purple-600">${total.toFixed(2)}</span>
      </div>

      {/* Pass cart, total, and userId to Payment */}
      <Payment cart={cart} total={total} userId={userId} amount={Math.round(total * 100)} />
    </div>
  );
};

export default Checkout;
